/**
 * Конвертирует число в строку с px.
 */
export const toPx = (value: number): string => `${value}px`;
